<app-loader [loading]="isLoading" type="fullPage"></app-loader>

<app-alert-popup *ngIf="alertData.alertVisible === 'success' || alertData.alertVisible === 'error'" [Data]="alertData" (confirm)="closeAlert()"
  (close)="closeAlert()"></app-alert-popup>

<div class="content">
  <div class="slider-container">
    <div class="slider-content">
      <img src="assets/vectors/iconGroup.svg" class="logo" [alt]="'app.linked_expired.logo' | translate"/>
      <div class="heading">{{ 'app.linked_expired.stay_on_right_side_of_law' | translate }}</div>
      <div class="pagination-dots">
        <span class="pagination-dot active"></span>
        <span class="pagination-dot"></span>
        <span class="pagination-dot"></span>
      </div>
    </div>
  </div>
  
  <div class="expired-form">
    <div class="logo">
      <img [src]="logoImageUrl" [alt]="'app.linked_expired.company_logo' | translate" />
    </div>
    
    <div class="expired-content">
      <h4>{{ 'app.linked_expired.link_expired' | translate }}</h4>

      <p class="description">
        {{ 'app.linked_expired.link_no_longer_valid' | translate }}
      </p>
      
      <div class="input-group buttons">
        <button ejs-button type="button" class="resend-btn" (click)="onResendLink()" [disabled]="isLoading">
          {{ 'app.linked_expired.request_new_reset_link' | translate }}
        </button>

        <button ejs-button type="button" class="back-to-login-btn" (click)="onBackToLogin()" *ngIf="!showHelpDetails">
          {{ 'app.linked_expired.back_to_login' | translate }}
        </button>
      </div>
      
      <div class="help-section">
        <p class="help-link" *ngIf="!showHelpDetails">
          {{ 'app.linked_expired.need_help_contact_support' | translate }}
          <a href="javascript:void(0)" class="link" (click)="toggleHelpDetails()">support&#64;regtrack.com</a>
        </p>
        
        <!-- Expanded state: Info box with details -->
        <div *ngIf="showHelpDetails">
          <div class="help-box">
            <div class="help-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" stroke="#125AAB" stroke-width="2" fill="white"/>
                <text x="10" y="14" font-size="12" font-weight="bold" fill="#125AAB" text-anchor="middle">i</text>
              </svg>
            </div>
            <div class="help-content">
              <p class="help-title">{{ 'app.linked_expired.need_help' | translate }}</p>
              <p class="help-text">{{ 'app.linked_expired.support_team_help_message' | translate }} <a href="mailto:support&#64;regtrack.com" class="link">support&#64;regtrack.com</a></p>
            </div>
          </div>
          
          <div class="back-link">
            <a href="javascript:void(0)" (click)="onBackToLogin()" class="link">{{ 'app.linked_expired.click_here_to_go_back' | translate }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>